import React from 'react';
import PropTypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { TConfiguratorChoice, TConfiguratorOption } from '../_propTypes';
import ColorSwatches from './ColorSwatches';

const ColorSwatchesContainer = ({ choices, option }) => {
  return (
    <QueryProvider cacheKey="color_swatches_metadata">
      <ColorSwatches choices={choices} option={option} />
    </QueryProvider>
  );
};

ColorSwatchesContainer.propTypes = {
  choices: PropTypes.arrayOf(TConfiguratorChoice).isRequired,
  // onChoiceSelected: PropTypes.func.isRequired,
  option: TConfiguratorOption.isRequired,
};

export default ColorSwatchesContainer;